import Extend from 'flarum/common/extenders';
import Discussion from 'flarum/common/models/Discussion';
import User from 'flarum/common/models/User';
import ScheduledPost from './models/ScheduledPost';
import ScheduledPostsPage from './components/ScheduledPostsPage';
import Model from 'flarum/common/Model';

export default [
	new Extend.Model(User) //
		.attribute<boolean>('canSchedulePosts')
		.attribute<number>('scheduledPostsCount'),

	new Extend.Model(Discussion) //
		.attribute<Date | null, string | null>('scheduledAt', Model.transformDate),

	new Extend.Store() //
		.add('scheduled_posts', ScheduledPost),

	new Extend.Routes() //
		.add('scheduled_posts', '/scheduled_posts', ScheduledPostsPage),
];
